//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {NsIcon} from '@nuskin/ns-icon';
import {NsAnimateHeight} from '@nuskin/design-components';

export default {
  name: 'CollapsibleSection',
  components: {NsIcon, NsAnimateHeight},
  props: {
    /**
     * If true, the arrow icon will not show and clicking the header will be disabled
     */
    notCollapsible: {
      type: Boolean,
      default: false
    },

    /**
     * Whether the section is open or not
     */
    open: {
      type: Boolean,
      default: undefined
    },

    /**
     * When not controlling the component with the 'open' prop, this will mount the component in the open state
     */
    startOpen: {
      type: Boolean,
      default: false
    },

    /**
     * Label for the Section header
     */
    label: {
      type: String,
      default: ''
    },

    /**
     * If true, skips this whole component
     */
    contentOnly: {
      type: Boolean,
      default: false
    },

    /**
     * If true, uses a darker background for the header
     */
    dark: {
      type: Boolean,
      default: false
    },

    /**
     * If true, adds styles to match product details when desktop
     */
    productDetails: {
      type: Boolean,
      default: false
    },

    /**
     * The section name to send to Google Analytics when it's opened for the first time
     */
    name: {
      type: String,
      default: ''
    },

    /**
     * The variant/product sku to send to Google Analytics when the section is opened for the first time
     */
    productSku: {
      type: String,
      default: ''
    },

    /**
     * The variant/product name/title to send to Google Analytics when it's opened for the first time
     */
    productName: {
      type: String,
      default: ''
    },

    /**
     * Static test value for the collapsible section component
     */
    testValue: {
      type: String,
      default: 'collapsibleSectionTestValue'
    }
  },
  data() {
    return {
      localOpen:
        this.notCollapsible ||
        (this.open === undefined ? this.startOpen : this.open),
      hasOpened: false
    };
  },
  computed: {
    mobileAndPhablet() {
      return this.$mq === 'mobile' || this.$mq === 'phablet';
    }
  },
  watch: {
    open(open) {
      if (!this.notCollapsible && open !== undefined) {
        this.localOpen = open;
      }
    }
  },
  methods: {
    handleClick() {
      if (!this.notCollapsible) {
        if (this.open !== undefined) {
          this.$emit('toggle', this.open);
          return;
        }

        this.$emit('toggle', this.localOpen);
        this.localOpen = !this.localOpen;
        if (this.localOpen && !this.hasOpened) {
          this.hasOpened = true;
          this.pushProductDetailSectionOpened();
        }
      }
    },
    pushProductDetailSectionOpened() {
      if (!this.name || !this.productSku) {
        return;
      }
      const event = {
        event: 'productDetailSectionOpened',
        ecommerce: {
          detail: {
            products: [
              {
                id: this.productSku,
                name: this.productName,
                sectionName: this.name
              }
            ]
          }
        }
      };
      this.$store.commit('nuskin/pushGoogleAnalyticsEvent', event);
    }
  }
};
